import { autoGeneratedReducer } from '@hh.ru/redux-create-reducer';

export interface SocialNetworksLinksModel {
    name: 'vk' | 'fb' | 'ok' | 'twitter' | 'instagram' | 'telegram' | 'viber' | 'dzen' | 'setka';
    url: string;
}

export default autoGeneratedReducer<SocialNetworksLinksModel[]>(null);
